import { render } from "./ConfigPane.vue?vue&type=template&id=16162860&ts=true"
import script from "./ConfigPane.vue?vue&type=script&lang=ts"
export * from "./ConfigPane.vue?vue&type=script&lang=ts"

import "./ConfigPane.vue?vue&type=style&index=0&id=16162860&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__